// Copyright 2025 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file google/rpc/code.proto (package google.rpc, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * The canonical error codes for gRPC APIs.
 *
 *
 * Sometimes multiple error codes may apply.  Services should return
 * the most specific error code that applies.  For example, prefer
 * `OUT_OF_RANGE` over `FAILED_PRECONDITION` if both codes apply.
 * Similarly prefer `NOT_FOUND` or `ALREADY_EXISTS` over `FAILED_PRECONDITION`.
 *
 * @generated from enum google.rpc.Code
 */
export const Code = proto3.makeEnum(
  "google.rpc.Code",
  [
    {no: 0, name: "OK"},
    {no: 1, name: "CANCELLED"},
    {no: 2, name: "UNKNOWN"},
    {no: 3, name: "INVALID_ARGUMENT"},
    {no: 4, name: "DEADLINE_EXCEEDED"},
    {no: 5, name: "NOT_FOUND"},
    {no: 6, name: "ALREADY_EXISTS"},
    {no: 7, name: "PERMISSION_DENIED"},
    {no: 16, name: "UNAUTHENTICATED"},
    {no: 8, name: "RESOURCE_EXHAUSTED"},
    {no: 9, name: "FAILED_PRECONDITION"},
    {no: 10, name: "ABORTED"},
    {no: 11, name: "OUT_OF_RANGE"},
    {no: 12, name: "UNIMPLEMENTED"},
    {no: 13, name: "INTERNAL"},
    {no: 14, name: "UNAVAILABLE"},
    {no: 15, name: "DATA_LOSS"},
  ],
);

